"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgChatbotFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M4 4v21h10.68L23 30.94V25h5V4zm14 6h3v3h-3zm-7 0h3v3h-3zm5 11c-2.75 0-5.19-1.51-5.94-3.67l1.88-.66A4.18 4.18 0 0016 19a4.18 4.18 0 004.06-2.33l1.88.66C21.19 19.49 18.75 21 16 21z" })));
}
exports.default = SvgChatbotFilled;
//# sourceMappingURL=ChatbotFilled.js.map